import { DOCUMENT } from '@angular/common';
import { Component, Inject, Input, OnDestroy } from '@angular/core';
import { Dossier } from '@app/core/interfaces/dossier';
import { WINDOW } from '@inshared/shared/util';
import { ConfirmationModalComponent } from '@app/my-zone/shared/modals/confirmation-modal/confirmation.modal';
import { AppRoutesEnum } from '@app/routes';
import * as fromRoot from '@app/store/app.reducer';
import { Store } from '@ngrx/store';
import { NewModal } from 'outshared-lib';
import { Subscription } from 'rxjs';
import * as fromClaims from '../../pages/claims/store/actions/claims.actions';
import { ClaimFunnelRoutesEnum } from '@app/claim-funnel/enums';
import { AppConfigService } from '@inshared/shared/core';

@Component({
    selector: 'ins-pending-claim-item',
    templateUrl: './pending-claim-item.component.html',
    styleUrls: ['./pending-claim-item.component.scss'],
})
export class PendingClaimItemComponent implements OnDestroy {
    public meldingen: any[] = [];
    public baseUrl: string;

    private subscriptions: Subscription = new Subscription();
    @Input() dossier: Dossier;

    constructor(
        private newModal: NewModal,
        private store$: Store<fromRoot.State>,
        private appConfigService: AppConfigService,
        @Inject(DOCUMENT) private document: Document,
        @Inject(WINDOW) private window: Window
    ) {
        this.baseUrl = this.document.location.origin;
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    public onVerwijderenClick(): boolean {
        const modalRef = this.newModal.open(ConfirmationModalComponent);

        modalRef.componentInstance.model = {
            title: 'Schademelding verwijderen?',
            body: 'Weet u zeker dat u deze schademelding wilt verwijderen?',
            bevestiging: 'Bevestigen',
            ontkenning: 'Annuleren',
        };

        const modalRefSubscription = modalRef
            .afterClosed$()
            .subscribe((response) => this._onSchadeMeldingVerwijderen(response));
        this.subscriptions.add(modalRefSubscription);

        return false;
    }

    public onAfrondenClick(): void {
        if (this.appConfigService.getConfig().enabledFeatures.newClaimfunnel) {
            this.window.location.href = `${this.baseUrl}/${AppRoutesEnum.ClaimFunnel}/${ ClaimFunnelRoutesEnum.Information}?damagetype=${this.dossier.aard_schadegeval_id}`;
        } else {
            this.window.location.href = `${this.baseUrl}${AppRoutesEnum.OldClaimFunnel}`;
        }

    }

    private _onSchadeMeldingVerwijderen(response: boolean): void {
        if (!response) {
            return;
        }

        this.store$.dispatch(
            new fromClaims.Cancel({
                dossier_volgnummer: this.dossier.dossier_volgnummer,
            })
        );
    }
}
